import { AttributePlaceUse } from 'types/api/attributes';

// Phase E Cycle 5 — values sourced from the canonical BE enum.
export const ATTRIBUTE_PLACE_USE = {
  group: AttributePlaceUse.Group,
  doctorProfile: AttributePlaceUse.DoctorProfile,
  both: AttributePlaceUse.Both,
  email: AttributePlaceUse.Email,
  report: AttributePlaceUse.Report
} as const satisfies Record<string, AttributePlaceUse>;
